import React, { Component } from 'react';
import '../iinc/iStyle.css';
import '../iinc/iGlobal';

class ISExtDriveDetail extends Component {
  constructor (props) {
    super(props);
    this.state = {
        stTitle: 'Detail',
        licencedoc_id: '',
        licence_name: '',
        licence_price: '',
        licence_category: '',
        licence_region: '',
        licence_currency: '',
        content_client_list: [],
        styleTb: 'table',
    }
  }

  loadData(id) {
      document.getElementById('loading-area').style.display = 'block'; 
  }
  
  componentDidMount() {
    
  }

  render() {
    
   return (
    <div className="main-container">
      <div className="mgT30">
            
        </div>
        <div id="loading-area" className="divHide loading"></div>
    </div>
   );
  }
}
 
export default ISExtDriveDetail;